// @flow
import * as React from 'react'
import { colors } from '../colors'

export const TwitterIcon = (props: {
  color?: string,
  size?: number
}): React.Node => {
  const color = props.color || colors.sand
  const size = props.size || 30

  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="twitter"
    >
      <path
        d="M14.9997 0C6.71553 0 0 6.71553 0 14.9997C0 23.2839 6.71553 30 14.9997 30C23.2839 30 30 23.2845 30 14.9997C30 6.71498 23.2845 0 14.9997 0ZM21.5248 9.60964L21.5187 9.6313L21.4954 9.6163H21.4887L21.4859 9.60853L21.4954 9.61464L21.5248 9.60964ZM21.4137 11.2022C21.1114 11.5877 20.7586 11.9308 20.3648 12.2222C20.3423 12.2366 20.3242 12.2571 20.3126 12.2812C20.301 12.3053 20.2964 12.3322 20.2993 12.3588C20.3493 14.093 19.8717 15.6772 18.8994 17.1037C17.7111 18.8472 16.0714 19.9212 13.9897 20.2971C12.6841 20.5421 11.3377 20.4535 10.0755 20.0394C9.49324 19.8501 8.93596 19.5911 8.41579 19.2681C8.39247 19.2537 8.36026 19.2459 8.34583 19.2054C9.82231 19.3442 11.1511 18.9772 12.3544 18.0704C12.1802 18.0591 12.0069 18.0363 11.8357 18.0021C10.8633 17.7674 10.1953 17.1838 9.83175 16.2513C9.80177 16.1741 9.81287 16.1597 9.89727 16.173C10.2438 16.2281 10.5977 16.2157 10.9395 16.1364C10.9503 16.1354 10.9608 16.1322 10.9704 16.1271C10.9799 16.1219 10.9883 16.1149 10.9951 16.1064L10.8335 16.0614C10.7807 16.0464 10.7274 16.032 10.6752 16.0142C9.61519 15.6583 8.85057 14.6044 8.83891 13.4877C8.83891 13.41 8.84391 13.3894 8.92443 13.4322C9.22719 13.5888 9.55694 13.6866 9.89616 13.7204C9.94225 13.7254 9.98945 13.7248 10.0627 13.7281C9.9267 13.6171 9.81121 13.5332 9.70681 13.4338C9.28182 13.0249 8.99947 12.4903 8.90139 11.9087C8.80332 11.3271 8.89471 10.7295 9.16209 10.2038C9.17541 10.1777 9.1904 10.1527 9.20262 10.1266C9.22872 10.0711 9.24982 10.0822 9.28369 10.1233C9.48357 10.3659 9.69871 10.5955 9.92781 10.8107C10.9267 11.7594 12.1609 12.4242 13.5027 12.7364C13.9255 12.8347 14.3556 12.8985 14.7887 12.9274C14.8742 12.9335 14.8826 12.9063 14.8681 12.8319C14.5666 11.2971 15.6189 9.8101 17.1653 9.59798C18.0671 9.47415 18.8484 9.73902 19.4975 10.3754C19.5188 10.3968 19.5459 10.4116 19.5755 10.4178C19.6051 10.424 19.6359 10.4214 19.6641 10.4104C20.2026 10.2922 20.7205 10.0942 21.2005 9.82287L21.2977 9.77067C21.096 10.3854 20.69 10.9125 20.1471 11.2644C20.2734 11.2616 20.3989 11.2446 20.5214 11.2138C20.6513 11.1872 20.7807 11.1583 20.9101 11.1217C21.0395 11.085 21.1583 11.0484 21.2805 11.0056C21.4026 10.9629 21.5209 10.9145 21.6575 10.8618C21.5851 10.9813 21.5036 11.0951 21.4137 11.2022V11.2022Z"
        fill={color}
      />
      <path
        d="M21.4891 9.61792H21.4958L21.4863 9.61182L21.4891 9.61792Z"
        fill={color}
      />
      <path
        d="M21.5255 9.60938L21.4961 9.61604L21.5194 9.63103L21.5255 9.60938Z"
        fill={color}
      />
    </svg>
  )
}
